import { render } from "./markdown.vue?vue&type=template&id=5ebf009e"
import script from "./markdown.vue?vue&type=script&lang=js"
export * from "./markdown.vue?vue&type=script&lang=js"
script.render = render

export default script